<template>
    <div class="flex mt-1 rounded-md shadow-sm">
        <input
            ref="input"
            value="value"
            class="w-full border-gray-300 rounded-md rounded-tr-none rounded-br-none"
            type="number"
            :placeholder="placeholder"
            @input="$emit('input', $event.target.value)"
        >
        <span
            class="inline-flex items-center px-3 text-sm text-gray-500 border border-l-0 border-gray-300 rounded-r-md bg-gray-50"
        >
            {{ suffix }}
        </span>
    </div>
</template>

<script>
import common from '../common';

export default {
    props: ['placeholder', 'value', 'suffix'],

    data() {
        return {
            common,
        };
    },

    methods: {
        focus() {
            this.$refs.input.focus();
        },
    },
};
</script>
